import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/Header';
import MessagesDropdown from '../../components/Header/MessagesDropdown';
import { useCurrentUser } from '../../utils';
import { useDarkMode } from '../../App';
import './MessagesPage.css';

const MessagesPage: React.FC = () => {
  const currentUser = useCurrentUser();
  const { darkMode } = useDarkMode();
  const [params] = useSearchParams();
  const conversationIdParam = params.get('c');
  const initialConversationId = conversationIdParam ? Number(conversationIdParam) : null;

  if (!currentUser?.id) {
    return null;
  }

  return (
    <div className={`messages-page ${darkMode ? 'dark' : ''}`} data-testid="messages-page">
      <Header />
      <main className="messages-page-main">
        <div className="messages-page-intro">
          <h1>Messages</h1>
          <p>Chat with buyers and sellers about vehicles you&apos;re interested in.</p>
        </div>
        <div className="messages-page-panel">
          <MessagesDropdown
            userId={currentUser.id}
            darkMode={darkMode}
            embedded
            initialConversationId={
              Number.isFinite(initialConversationId) ? initialConversationId : null
            }
          />
        </div>
      </main>
    </div>
  );
};

export default MessagesPage;
